<!-- 文书list  -->
<template>
  <div>
    <div class="essay-edit-item"
         v-for="(item, index) in billsList"
         :key="index">
      <div>
        <h1>{{item.title}}</h1>
        <ul class="essay-edit-item-ul">
          <!-- class="zlr-cover" -->
          <li v-for="(smItem, smIndex) in item.smEdit"
              :key="'sm'+smIndex">
            <!-- orange green blue gray-->
            <zlr-card-simple title="SM Edit"
                             :avatar="smItem.mentorHead || MentorAvatar"
                             :circleSign="smItem | filterColor"
                             :con="(userRole === 'SM' && smItem.status === 'NOTEDIT') ? `<span style='font-size:12px;display: inline-block;line-height: 18px;margin-top: 12px;'>(${smItem.timeZone})${smItem.deadlineTime}  Edit turnaround DDL</span>`:'' ">
              <a class="blue"
                 @click="handleDownlod(smItem.menteeEdit)"
                 v-if="userRole === 'SM' && smItem.status === 'NOTEDIT'">Download</a>
              <a class="blue"
                 @click="uploadHandle('SMEDIT', item.id, smItem.id, smItem.jointId)"
                 v-if="userRole === 'SM' && smItem.status === 'NOTEDIT' ">Upload</a>
              <a class="blue"
                 style="position:relative;z-index:101"
                 v-if="userRole === 'SM' && smItem.status === 'EDITED' "
                 @click="handleFeedback(smItem.mentorEdit)">Feedback</a>
            </zlr-card-simple>
          </li>
          <li v-for="(emItem, emIndex) in item.emEdit"
              :key="'em'+emIndex">
            <zlr-card-simple title="EM Edit"
                             :avatar="emItem.mentorHead || MentorAvatar"
                             :circleSign="emItem | filterColor"
                             :con="(userRole === 'EM'&& emItem.status === 'NOTEDIT')? `<span style='font-size:12px;display: inline-block;line-height: 18px;margin-top: 12px;'>(${emItem.timeZone})${emItem.deadlineTime}  Edit turnaround DDL</span>`:'' ">
              <a class="blue"
                 @click="handleDownlod(emItem.menteeEdit)"
                 v-if="userRole === 'EM' && emItem.status === 'NOTEDIT'">Download</a>
              <a class="blue"
                 @click="uploadHandle('EMEDIT',  item.id, emItem.id, emItem.jointId)"
                 v-if="userRole === 'EM' && emItem.status === 'NOTEDIT' ">Upload</a>
              <a class="blue"
                 style="position:relative;z-index:101"
                 v-if="userRole === 'EM' && emItem.status === 'EDITED' "
                 @click="handleFeedback(emItem.mentorEdit)">Feedback</a>
            </zlr-card-simple>
          </li>
        </ul>
      </div>
    </div>
    <div class="essay-edit-item">
      <div>
        <h1>Service note</h1>
        <div class="essay-edit-note">
          <div class="essay-edit-note-item"
               v-if="userRole === 'SM'">
            <span>Module 4 (Max time)</span>
            <span>{{scheduleTime.maxTime}}mins (If the mentee has not confirmed the number of programs, the max time is 0)</span>
          </div>
          <div class="essay-edit-note-item">
            <span>Module 4 (Used time)</span>
            <span>{{scheduleTime.usedTime}}mins</span>
          </div>
          <div class="essay-edit-note-item"
               v-if="userRole === 'SM'">
            <span>Module 4 (Remaining time)</span>
            <span>{{scheduleTime.remainTime}}mins</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 上传文书 -->
    <essay-upload ref="upload"
                  :upData='upData'
                  @on-success="getSingleProject"></essay-upload>
    <!-- 查看feedback -->
    <feedback ref="feedback"
              :data="feedbackData"></feedback>
  </div>
</template>

<script>
// imgage
import MentorAvatar from '@/assets/images/home/mentor-avatar.svg'
// api
import { ossSecretLink, downFile } from '@/api/oss'
import { getMaterialSingleProject } from '@/api/material'
import { getTimesheetMaterialSchedule } from '@/api/timesheet'
// components
import ZlrCardSimple from '_c/card-simple/card-simple'
import EssayUpload from './essay-upload'
import Feedback from './essay-feedback'
import { mapState } from 'vuex'
export default {
  name: 'program-essay-modify-list',
  components: {
    ZlrCardSimple,
    EssayUpload,
    Feedback
  },
  data () {
    return {
      MentorAvatar,
      billsList: [],
      programId: this.$route.params.programId,
      num: this.$route.params.id,
      upData: {},
      feedbackData: {},
      scheduleTime: {}
    }
  },
  computed: {
    ...mapState({
      userRole (state) {
        return state.user.userRole
      }
    })
  },
  mounted () {
    this.getSingleProject()
    this.getTimesheetMaterialSchedule()
  },
  methods: {
    uploadHandle (type, id, itemId, jointId) {
      this.upData = {
        type,
        id,
        itemId,
        jointId
      }
      this.$refs['upload'].showHandle()
    },
    // 获取list
    getSingleProject () {
      getMaterialSingleProject({
        id: this.programId
      }).then(res => {
        this.billsList = res.data.model.progress.bills
      })
    },
    // 下载
    handleDownlod ({ url, fileName }) {
      ossSecretLink({
        dir: url
      }).then(res => {
        this.downFile(res.data.url, fileName)
      })
    },
    // 下载二进制文件
    downFile (url, filename) {
      downFile({
        filename,
        url
      })
    },
    // 查看feedback
    handleFeedback (data) {
      this.feedbackData = data
      this.$refs['feedback'].handleShow()
    },
    getTimesheetMaterialSchedule () {
      getTimesheetMaterialSchedule({
        menteeNum: this.$route.params.id,
        module: 'MODULE_4'
      }).then(res => {
        this.scheduleTime = res.data.model
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    }
  },
  filters: {
    filterColor (item) {
      let color = ''
      if (item.status === 'EDITED') {
        color = 'green'
      } else if (item.status === 'NOTEDIT') {
        color = 'orange'
      }
      return color
    }
  }
}
</script>
<style lang='less' scoped>
</style>
